import Element from '../../../Prototype/UI/Element';
import { IUIElementLayout } from '../../../Prototype/UI/UIItem';

export default class StarChestProgressBar extends Element {
    public create(params: {
        name?: string;
        layout?: Partial<IUIElementLayout>;
    }): void {
        super.create({
            name: params.name,
            layout: {
                anchors: [0.5, 0.5, 0.5, 0.5],
                pivot: [0.5, 0.5],
                offsets: [0, 0, 0, 0],
                scale: [1, 1],
                ...params.layout,
            },
            children: [
                {
                    name: 'star_chest_progress_bar_container',
                    layout: {
                        anchors: [0.5, 0.5, 0.5, 0.5],
                        pivot: [0.5, 0.5],
                        offsets: [0, 100, 0, 100],
                        scale: [1, 1],
                        constrains: {
                            heightMin: 58,
                            heightMax: 58,
                            widthMin: 450,
                            widthMax: 450,
                        },
                    },
                    children: [
                        {
                            name: 'progress_bar',
                            layout: {
                                anchors: [0.5, 0.5, 0.5, 0.5],
                                pivot: [0.5, 0.5],
                                offsets: [0, 0, 0, 0],
                                scale: [1, 1],
                            },
                            components: [
                                {
                                    type: 'nineslice',
                                    data: {
                                        cacheKey: 'progressbar_bg',
                                        offset: [15, 80, 15, 80],
                                    },
                                },
                            ],
                            children: [
                                {
                                    name: 'progress_bar_fill',
                                    layout: {
                                        anchors: [0, 0.5, 0, 0.5],
                                        pivot: [0, 0.5],
                                        offsets: [0, 0, 0, 0],
                                        scale: [0.5, 1],
                                        constrains: {
                                            heightMin: 40,
                                            heightMax: 40,
                                            widthMin: 430,
                                            widthMax: 430,
                                        },
                                    },
                                    components: [
                                        {
                                            type: 'nineslice',
                                            data: {
                                                cacheKey:
                                                    'progressbar_greenbar',
                                                offset: [0, 30, 0, 30],
                                            },
                                        },
                                    ],
                                },
                                {
                                    name: 'progress_bar_text_group',
                                    layout: {
                                        anchors: [0.5, 0.5, 0.5, 0.5],
                                        pivot: [0.5, 0.5],
                                        offsets: [0, -5, 0, -5],
                                        scale: [1, 1],
                                    },
                                    children: [
                                        {
                                            name: 'progress_bar_text',
                                            layout: {
                                                anchors: [0.5, 0.5, 0.5, 0.5],
                                                pivot: [0.5, 0.5],
                                                offsets: [0, 0, 0, 0],
                                                scale: [1, 1],
                                            },
                                            components: [
                                                {
                                                    type: 'text',
                                                    data: {
                                                        text: '0 / 0',
                                                        style:
                                                            'star_chest.progress',
                                                    },
                                                },
                                            ],
                                        },
                                    ],
                                },
                                {
                                    name: 'progress_bar_cover',
                                    layout: {
                                        anchors: [0.5, 0.5, 0.5, 0.5],
                                        pivot: [0.5, 0.5],
                                        offsets: [0, 0, 0, 0],
                                        scale: [1, 1],
                                    },
                                    components: [
                                        {
                                            type: 'nineslice',
                                            data: {
                                                cacheKey: 'progressbar_forebg',
                                                offset: [15, 80, 15, 80],
                                            },
                                        },
                                    ],
                                },
                            ],
                        },
                        {
                            name: 'current_icon',
                            layout: {
                                anchors: [0.05, 0.5, 0.05, 0.5],
                                pivot: [0.5, 0.5],
                                offsets: [0, 0, 0, 0],
                                scale: [1.1, 1.1],
                            },
                            components: [
                                {
                                    type: 'image',
                                    data: {
                                        cacheKey: 'progressbar_icon1',
                                    },
                                },
                            ],
                        },
                        {
                            name: 'progress_bar_star_destination',
                            layout: {
                                anchors: [1, 0.5, 1, 0.5],
                                pivot: [0.5, 0.5],
                                offsets: [0, 0, 0, 0],
                                scale: [1.1, 1.1],
                                constrains: {
                                    heightMin: 1,
                                    heightMax: 1,
                                    widthMin: 1,
                                    widthMax: 1,
                                },
                            },
                        },
                        {
                            name: 'next_icon',
                            layout: {
                                anchors: [1, 0.5, 1, 0.5],
                                pivot: [0.5, 0.5],
                                offsets: [0, 0, 0, 0],
                                scale: [1.1, 1.1],
                            },
                            components: [
                                {
                                    type: 'image',
                                    data: {
                                        cacheKey: 'progressbar_icon2',
                                    },
                                },
                            ],
                        },
                    ],
                },
                {
                    name: 'animated_chest',
                    layout: {
                        anchors: [0.5, 0.5, 0.5, 0.5],
                        pivot: [0.5, 0.5],
                        offsets: [200, -60, 200, -60],
                        scale: [1, 1],
                    },
                    components: [
                        {
                            type: 'image',
                            data: {
                                cacheKey: 'blank',
                            },
                        },
                        {
                            type: 'visibility',
                            data: {
                                hidden: true,
                            },
                        },
                    ],
                },
                {
                    name: 'off_screen_star_spawn',
                    layout: {
                        anchors: [0, 1.25, 0, 1.25],
                        pivot: [0.5, 0.5],
                        offsets: [0, 0, 0, 0],
                        scale: [1, 1],
                    },
                    components: [
                        {
                            type: 'image',
                            data: {
                                cacheKey: 'blank',
                            },
                        },
                    ],
                },
            ],
        });
    }
}
